import AppendAction from './AppendAction';
import AssociationAction from './AssociationAction';
import AttachEventAction from './AttachEventAction';
import BoundaryEventAction from './BoundaryEventAction';
import RootElementAction from './RootElementAction';
import CreateAction from './CreateAction';
import FixHoverAction from './FixHoverAction';
import CreateDataObjectAction from './CreateDataObjectAction';
import CreateParticipantAction from './CreateParticipantAction';
import DataInputAction from './DataInputAction';
import DataStoreAction from './DataStoreAction';
import DeleteDefaultFlowAction from './DeleteDefaultFlowAction';
import DeleteLaneAction from './DeleteLaneAction';
import DetachEventAction from './DetachEventAction';
import DropOnFlowAction from './DropOnFlowAction';
import ElementCollapseAction from './ElementCollapseAction';
import EventBasedGatewayAction from './EventBasedGatewayAction';
import GroupAction from './GroupAction';
import ImportDockingFix from './ImportDockingFix';
import IsHorizontalFix from './IsHorizontalFix';
import LabelAction from './LabelAction';
import LabelPositioningAction from './LabelPositioningAction';
import MessageFlowAction from './MessageFlowAction';
import ModelError from './ModelError';
import RemoveElementAction from './RemoveElementAction';
import RemoveParticipantAction from './RemoveParticipantAction';
import ReplaceConnectionAction from './ReplaceConnectionAction';
import ReplaceElementAction from './ReplaceElementAction';
import ResizeAction from './ResizeAction';
import ResizeLaneAction from './ResizeLaneAction';
import SpaceToolAction from './SpaceToolAction';
import SubProcessStartEventAction from './SubProcessStartEventAction';
import UnclaimModelIdAction from './UnclaimModelIdAction';
import UpdateFlowNodeRefsAction from './UpdateFlowNodeRefsAction';

export default {
  __init__: [
    'appendAction',
    'associationAction',
    'attachEventAction',
    'boundaryEventAction',
    'rootElementAction',
    'createAction',
    'fixHoverAction',
    'createDataObjectAction',
    'createParticipantAction',
    'dataInputAction',
    'dataStoreAction',
    'deleteDefaultFlowAction',
    'deleteLaneAction',
    'detachEventAction',
    'dropOnFlowAction',
    'elementCollapseAction',
    'eventBasedGatewayAction',
    'groupAction',
    'importDockingFix',
    'isHorizontalFix',
    'labelAction',
    'labelPositioningAction',
    'messageFlowAction',
    'modelError',
    'removeElementAction',
    'removeParticipantAction',
    'replaceConnectionAction',
    'replaceElementAction',
    'resizeAction',
    'resizeLaneAction',
    'spaceToolAction',
    'subProcessStartEventAction',
    'unclaimModelIdAction',
    'updateFlowNodeRefsAction'
  ],
  labelPositioningAction: [ 'type', LabelPositioningAction ],
  appendAction: [ 'type', AppendAction ],
  associationAction: [ 'type', AssociationAction ],
  attachEventAction: [ 'type', AttachEventAction ],
  boundaryEventAction: [ 'type', BoundaryEventAction ],
  rootElementAction: [ 'type', RootElementAction ],
  createAction: [ 'type', CreateAction ],
  fixHoverAction: [ 'type', FixHoverAction ],
  createDataObjectAction: [ 'type', CreateDataObjectAction ],
  createParticipantAction: [ 'type', CreateParticipantAction ],
  dataInputAction: [ 'type', DataInputAction ],
  dataStoreAction: [ 'type', DataStoreAction ],
  deleteDefaultFlowAction: [ 'type', DeleteDefaultFlowAction ],
  deleteLaneAction: [ 'type', DeleteLaneAction ],
  detachEventAction: [ 'type', DetachEventAction ],
  dropOnFlowAction: [ 'type', DropOnFlowAction ],
  elementCollapseAction : [ 'type', ElementCollapseAction ],
  eventBasedGatewayAction: [ 'type', EventBasedGatewayAction ],
  groupAction: [ 'type', GroupAction ],
  importDockingFix: [ 'type', ImportDockingFix ],
  isHorizontalFix: [ 'type', IsHorizontalFix ],
  labelAction: [ 'type', LabelAction ],
  messageFlowAction: [ 'type', MessageFlowAction ],
  modelError: [ 'type', ModelError ],
  removeElementAction: [ 'type', RemoveElementAction ],
  removeParticipantAction: [ 'type', RemoveParticipantAction ],
  replaceConnectionAction: [ 'type', ReplaceConnectionAction ],
  replaceElementAction: [ 'type', ReplaceElementAction ],
  resizeAction: [ 'type', ResizeAction ],
  resizeLaneAction: [ 'type', ResizeLaneAction ],
  spaceToolAction: [ 'type', SpaceToolAction ],
  subProcessStartEventAction: [ 'type', SubProcessStartEventAction ],
  unclaimModelIdAction: [ 'type', UnclaimModelIdAction ],
  updateFlowNodeRefsAction: [ 'type', UpdateFlowNodeRefsAction ]
};
